export default {
  EMPTY: 'EMPTY',
  UPLOADING: 'UPLOADING',
  COMPLETED: 'COMPLETED',
  UPLOAD_ERROR: 'UPLOAD_ERROR',
  FILE_TYPE_ERROR: 'FILE_TYPE_ERROR',
};
